// music pause icon 

export default function PauseIcon({idx, onClick}) {
    return (
        <svg key={idx} onClick={onClick} style={{cursor: "pointer"}} xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewBox="0 0 48 48" fill="none">
            <rect width="48" height="48" rx="24" fill="#0069FD"/>
            <rect x="13" y="14" width="8" height="21" fill="#D9D9D9"/>
            <path d="M27 14H34V35H27V14Z" fill="#D9D9D9"/>
        </svg>
    );
}